import React, { useImperativeHandle } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'

// mui
import { Grid } from '@mui/material';

// components
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import CrewAssignment from '../../../../../components/forms/lists/CrewAssignment/CrewAssignment.component';
import InputField from '../../../../../components/forms/InputField/InputField.component';

const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent',
    A: 'Admin',
    C: 'Clerk',
}

const FinishTimeTickets = React.forwardRef(({ prefillData = null, errors }, ref) => {

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData } : {
            assignments: []
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormDataPoint label='Job' value={prefillData['jobDay'] ? prefillData.jobDay.job.name : "Unknown"} />
            <FormDataPoint label='Scope' value={prefillData['jobDay'] ? prefillData.jobDay.scopeOfWork : "Unknown"} />

            <FormSectionHeader text='Crew Assignments' />

            <FieldArray 
                name="crewAssignments"
                render={() => (
                    <React.Fragment>
                        {
                            formik.values.assignments.map((assignment, index) => {
                                return (<CrewAssignment 
                                    key={index}
                                    variant='finish-time-tickets'
                                    id={index}
                                    data={{
                                        title: `${assignment.crewMember.firstName} ${assignment.crewMember.lastName}`,
                                        subTitle: CREW_MEMBER_CLASS_CHOICES[assignment.crewMember.classification],
                                    }}           
                                >
                                    <Grid item xs={6}>
                                        <InputField 
                                            id={`assignments.${index}.startTime`}
                                            placeholder='Start Time'
                                            type='time'
                                            onChange={value => formik.setFieldValue(`assignments.${index}.startTime`, value)}
                                            value={assignment.startTime}  
                                            isValid={errors['assignments'].length > index ? errors['assignments'][index]['startTime'] : true}  
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputField 
                                            placeholder='End Time'
                                            id={`assignments.${index}.endTime`}
                                            type='time'
                                            onChange={value => formik.setFieldValue(`assignments.${index}.endTime`, value)}
                                            value={assignment.endTime}
                                            isValid={errors['assignments'].length > index ? errors['assignments'][index]['endTime'] : true}
                                        />
                                     </Grid>
                                </CrewAssignment>)
                            })
                        }
                    </React.Fragment>
                )}
            />
        </form>
    </FormikProvider>)
})

export default FinishTimeTickets